import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "stream-content" }
const _hoisted_2 = {
  key: 0,
  class: "stream-message"
}
const _hoisted_3 = {
  key: 1,
  class: "stream-message"
}
const _hoisted_4 = {
  key: 2,
  class: "stream-message"
}
const _hoisted_5 = {
  key: 3,
  class: "stream-ratio"
}
const _hoisted_6 = ["src"]

import { computed, onMounted, onUnmounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import BaseModal from './BaseModal.vue'
import { useAuthStore } from '@/stores/auth'
import { useStreamStore } from '@/stores/stream'


const __default__ = {
  name: 'VideoLiveStream',
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    gameSlug: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t, te } = useI18n()
const authStore = useAuthStore()
const streamStore = useStreamStore()
const { isLoading, embedUrl, error } = storeToRefs(streamStore)

const isAuthenticated = computed(() => authStore.isAuthenticated)

const displayError = computed(() => {
  const key = error.value
  if (key && te(key)) {
    return t(key)
  }
  return key || t('stream.unavailable')
})

onMounted(() => {
  streamStore.clearStream()
  if (isAuthenticated.value) {
    streamStore.fetchStreamingVideo(props.gameSlug)
  }
})

onUnmounted(() => {
  streamStore.clearStream()
})

const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-open": true,
    title: _ctx.$t('stream.watchLive'),
    size: "stream",
    "hide-footer": "",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!isAuthenticated.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('stream.loginRequired')), 1))
          : (_unref(error))
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(displayError.value), 1))
            : (_unref(isLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('stream.loading')), 1))
              : (_unref(embedUrl))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("iframe", {
                      class: "livestream",
                      src: _unref(embedUrl),
                      frameborder: "0",
                      allow: "autoplay; fullscreen",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_6)
                  ]))
                : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})